import { render, staticRenderFns } from "./ShadowComponent.vue?vue&type=template&id=0412cfce"
import script from "./ShadowComponent.vue?vue&type=script&lang=js"
export * from "./ShadowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports